import _ from 'lodash'

import {
  VuetifyTiptap,
  VuetifyViewer,
  createVuetifyProTipTap,
  BaseKit,
  Bold,
  Italic,
  Underline,
  Strike,
  Color,
  Highlight,
  Heading,
  TextAlign,
  FontFamily,
  FontSize,
  SubAndSuperScript,
  BulletList,
  OrderedList,
  TaskList,
  Indent,
  Link,
  Clear,
  History
} from 'vuetify-pro-tiptap'

import 'vuetify-pro-tiptap/style.css'

const customBubbleList = (editor) => [
  { name: 'bold', icon: 'mdi-format-bold', command: () => editor.chain().focus().toggleBold().run() },
  { name: 'italic', icon: 'mdi-format-italic', command: () => editor.chain().focus().toggleItalic().run() },
  { name: 'underline', icon: 'mdi-format-underline', command: () => editor.chain().focus().toggleUnderline().run() },
  { name: 'strike', icon: 'mdi-format-strikethrough', command: () => editor.chain().focus().toggleStrike().run() },
  { name: 'color', icon: 'mdi-format-color-text', command: () => {/* color picker */} },
  { name: 'highlight', icon: 'mdi-marker', command: () => {/* highlight */} },
  { name: 'textAlign', icon: 'mdi-format-align-left', command: () => {/* alignment */} },
  { name: 'link', icon: 'mdi-link', command: () => {/* link */} },
]

export const getExtensions = (extensions = null) => {
  const baseKitConfiguration = {
    bubble: {
      list: {
        text: [
          'bold',
          'italic',
          'underline',
          'strike',
          'divider',
          'color',
          'highlight',
          'textAlign',
          'divider',
          'link'
        ]
      },
      defaultBubbleList: customBubbleList
    }
  }
  baseKitConfiguration.characterCount =
    extensions != null && _.has(extensions, 'characterCount') && _.isBoolean(extensions.characterCount)
      ? extensions.characterCount
      : true
  if (extensions != null) {
    if (_.has(extensions, 'placeholder'))
      baseKitConfiguration.placeholder = { placeholder: extensions.placeholder }
  }
  return [
    BaseKit.configure(baseKitConfiguration),
    Bold,
    Italic,
    Underline,
    Strike,
    TextAlign,
    FontFamily,
    FontSize,
    Color,
    Highlight,
    Heading,
    SubAndSuperScript,
    Clear,
    BulletList,
    OrderedList,
    TaskList,
    Indent,
    Link,
    History
  ]
}

export const vuetifyProTipTap = createVuetifyProTipTap({
  markdownTheme: 'github',
  components: {
    VuetifyTiptap,
    VuetifyViewer
  },
  extensions: getExtensions()
})